<template>
  <div v-frag class="prism-elite-app">
    <CardIeaAppMain colorCard="#0F172A" title="">
      <v-col cols="12" class="pa-0 main-container-glass">
        <!-- Top Bar -->
        <div class="prism-top-bar d-flex align-center justify-space-between px-8 py-5">
           <div class="d-flex align-center">
            <v-btn
              icon
              @click="$router.push({ name: 'Home' })"
              class="mr-4 glass-btn"
              large
            >
              <v-icon color="primary">mdi-arrow-left-circle-outline</v-icon>
            </v-btn>
             <div>
              <h1 class="text-h6 font-weight-black prism-title mb-0">Secretaría Virtual</h1>
              <div class="text-caption grey--text font-weight-medium">Atención y Soporte en Tiempo Real</div>
            </div>
           </div>
        </div>

        <v-divider class="prism-divider"></v-divider>

        <v-row class="pa-8">
          <!-- Welcome Message -->
          <v-col cols="12" class="mb-4">
             <div class="d-flex align-center mb-2">
                <v-avatar size="32" color="primary lighten-5" class="mr-3">
                   <v-icon color="primary" size="18">mdi-account-tie-voice</v-icon>
                </v-avatar>
                <h2 class="text-h5 font-weight-black prism-heading">Canales de Atención</h2>
             </div>
             <p class="text-body-2 grey--text text--darken-1 mb-8">
               Seleccione el área de su interés para ingresar a la sala de videoconferencia en los horarios indicados.
             </p>
          </v-col>

          <!-- Empty State -->
          <v-col cols="12" v-if="horarios.length == 0 && show == true">
            <v-alert
              outlined
              color="primary"
              class="rounded-xl glass-alert pa-8 text-center"
            >
              <v-icon size="48" color="primary" class="mb-4">mdi-calendar-clock-outline</v-icon>
              <div class="text-h6 font-weight-black primary--text mb-2">Sin Horarios Disponibles</div>
              <div class="text-body-2 primary--text opacity-70">No hay canales de atención activos en este momento. Por favor, intente más tarde.</div>
            </v-alert>
          </v-col>

          <!-- Schedules Grid -->
          <v-col v-else cols="12">
            <v-row>
               <v-col v-for="(item, index) in horarios" :key="index" cols="12" md="6" lg="4">
                  <v-card flat class="rounded-xl glass-card-interactive overflow-hidden h-full d-flex flex-column">
                     <div class="pa-6 flex-grow-1">
                        <div class="d-flex align-center mb-6">
                           <v-avatar size="44" color="primary lighten-5" class="mr-4 elite-avatar-glow">
                              <v-icon color="primary" size="22">mdi-human-greeting-proximity</v-icon>
                           </v-avatar>
                           <div>
                              <div class="text-subtitle-1 font-weight-black mb-0 line-clamp-1">{{ item.titulo }}</div>
                              <v-chip x-small color="success" class="font-weight-black uppercase" label dark>SOPORTE ACTIVO</v-chip>
                           </div>
                        </div>

                        <div class="elite-time-box pa-4 rounded-xl mb-6">
                           <div class="d-flex align-center mb-1">
                              <v-icon x-small color="primary" class="mr-2">mdi-clock-outline</v-icon>
                              <span class="text-tiny grey--text font-weight-bold uppercase">Ventana de Atención</span>
                           </div>
                           <div class="text-h6 font-weight-black primary--text">
                              {{ item.horaDesde }} <span class="grey--text mx-1 opacity-50">–</span> {{ item.horaHasta }}
                           </div>
                        </div>

                        <p v-if="item.notas" class="text-caption grey--text text--darken-2 mb-6 italic line-clamp-3">
                           "{{ item.notas }}"
                        </p>

                        <v-btn
                          block
                          color="primary"
                          x-large
                          depressed
                          class="rounded-xl font-weight-black shadow-glow mt-auto"
                          :href="item.meet"
                          target="_blank"
                        >
                          INGRESAR AL ENLACE
                          <v-icon right small>mdi-video-outline</v-icon>
                        </v-btn>
                     </div>
                  </v-card>
               </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Secretaria",
  components: {
    CardIeaAppMain,
  },

  data() {
    return {
      horarios: [],
      show: false, 
    };
  },
 
  methods: {
    listaHorarios() {
      this.$API
        .get({
          url: "secretaria/B",
        })
        .then((res) => {
          this.horarios = res;
          this.show = true;
        });
    },
  },

   mounted() {
    if(this.$store.getters.user.borrado == 1 ||  this.$store.getters.user.alumno_mora ==  true){
      this.$router.push({
          name: "Home"
        });
    }
    this.listaHorarios();
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Outfit:wght@700;900&display=swap");

.prism-elite-app {
  font-family: "Inter", sans-serif !important;
  background: radial-gradient(circle at 100% 100%, #0f172a 0%, #1e293b 100%);
  min-height: 100vh;
}

h1, h2, h3, .prism-heading, .text-overline {
  font-family: "Outfit", sans-serif !important;
  letter-spacing: -0.5px;
}

.main-container-glass {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  min-height: 90vh;
}

.prism-top-bar { background: transparent; }
.prism-divider { border-color: rgba(0,0,0,0.05) !important; }

/* Elite Cards */
.glass-card-interactive {
  background: white;
  border: 1px solid #f1f5f9 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05) !important;
}
.glass-card-interactive:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px -15px rgba(26, 35, 126, 0.1) !important;
  border-color: #1a237e !important;
}

.glass-alert {
  background: rgba(239, 246, 255, 0.5) !important;
  border: 1px solid #dbeafe !important;
}

.elite-avatar-glow {
  box-shadow: 0 0 15px rgba(26, 35, 126, 0.1);
}

/* Time Box */
.elite-time-box {
  background: #f8fafc;
  border: 1px solid #f1f5f9;
}

.shadow-glow {
  box-shadow: 0 10px 20px -5px rgba(26, 35, 126, 0.3) !important;
}

.text-tiny { font-size: 0.75rem !important; }
.uppercase { text-transform: uppercase; }
.line-clamp-1 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.h-full { height: 100%; }

.opacity-70 { opacity: 0.7; }
.opacity-50 { opacity: 0.5; }

.italic { font-style: italic; }
</style>